<template>
  <div class="analytics" v-loading="loading">
    <div class="subscribers-header">
      <div class="subscribers-count">
        {{$t('feed.activeUsers.amount')}}: <b>{{count}}</b>
      </div>

      <el-button type="primary" v-if="activities" class="subscribers-activities-button" @click="backToUsersList" round>Назад</el-button>

      <ul class="subscribers-links">
        <!--<li class="subscribers-links__item">
          <el-link
            :href="`http://dl.glassen-it.ru/allmembers_doc?thread_id=${$route.params.threadId}`"
            target="_blank"
          >
            <i class="fas fa-file-word fa-2x"></i>
          </el-link>
        </li>-->
        <li class="subscribers-links__item" v-if="!activities">
          <el-link
            @click="getXls"
          >
            <i class="fas fa-file-excel fa-2x"></i>
          </el-link>
        </li>
      </ul>
    </div>
    <el-divider></el-divider>

    <div v-if="subscribers.length">
      <template v-if="!activities">
        <ul class="subscribers-list" >
          <li class="subscribers-list__item" v-for="(subscriber, index) in subscribers" :key="index">
            <div class="pseudo-link-wrap" @click="getActivities(subscriber)">
              <el-tooltip class="item" effect="light" :content="subscriber.name" placement="top">
                <el-avatar :src="subscriber.image" size="large"></el-avatar>
              </el-tooltip>
            </div>
            <div class="subscribers-list__item--coefficient">
              {{subscriber.coefficient}}
            </div>
            <div class="subscribers-list__item--coefficient">
              {{subscriber.name}}
            </div>
          </li>
        </ul>
        <div class="subscribers__button-wrap" v-if="subscribers.length <= count">
          <el-button @click="getActiveSubscribers">{{$t('feed.activeUsers.button')}}</el-button>
        </div>
      </template>
      <template v-else>
        <user-posts :loading="loading" :posts="posts" @toggleComment="toggleComment"/>
      </template>

    </div>

    <ul class="subscribers-list" v-else>
      <template v-if="isLoaded">
        <li>
          {{$t('feed.activeUsers.noData')}}.
        </li>
      </template>
      <template v-else>
        <li class="subscribers-list__item" v-for="item in limit" :key="item">
          <el-avatar  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" size="large"></el-avatar>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  /*active users component from tabs directory of analytics*/

  // api
  import { getActiveSubscribersApi, GetXlsLink } from "../../../../../../api/stats";

  import { getActivitiesApi } from "../../../../../../api/users";

  // components
  import UserPosts from "./components/userPost/userPosts";

  export default {
    name: "Users",
    props: {
      active: {
        type: Boolean
      }
    },
    data() {
      return {
        activities: false,
        isLoaded: false,
        loading: false,
        posts: [],
        subscribers: [],
        count: 0,
        start: 0,
        limit: 120,
      };
    },
    methods: {
      toggleComment(post) {
        if (post.showComment === undefined) {
          this.$set(post, 'showComment', true);
          this.$set(post, 'firstLoad', true);
        } else {
          post.showComment = !post.showComment;
          post.firstLoad = false;
        }
      },
      backToUsersList() {
        this.activities = false;
        this.posts = [];
      },
      getActivities(subscriber) {
        this.activities = true;
        this.loading = true;

        let params = {
          thread_id: Number(this.$route.params.threadId),
          user_id: Number(subscriber.id),
          network_id: Number(subscriber.network_id),
        };

        getActivitiesApi(params).then(resp => {
          this.loading = false;
          this.posts = resp.data.posts;
        });
      },
      getXls() {
        this.loading = true;

        let params = {
          thread_id: this.$route.params.threadId,
          start: 0,
          limit: 1000,
        };
        GetXlsLink(params).then(resp => {
          document.location = resp.data.xls_link;
          this.loading = false;
        });
      },
      goToLink(subscriber) {
        window.open(subscriber.url, '_blank');
      },
      getActiveSubscribers() {
        this.loading = true;

        const params = {
          thread_id: this.$route.params.threadId,
          start: this.start,
          limit: this.limit,
        };

        getActiveSubscribersApi(params).then(resp => {
          this.subscribers = [...this.subscribers, ...resp.data.users];
          this.start = this.subscribers.length;
          this.count = resp.data.count;
          this.loading = false;
          this.isLoaded = true;
        });
      },
    },
    watch: {
      active(value) {
        if (value) {
          if (!this.subscribers.length) {
            this.getActiveSubscribers();
          }
        }
      }
    },
    components: {
      UserPosts
    }
  };
</script>

<style>
  .analytics {
    padding-top: 29px;
  }
  .subscribers-list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .subscribers-list__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 15px;
    margin-bottom: 15px;
  }
  .subscribers-list__item--coefficient {
    width: 60px;
    padding-top: 6px;
    text-align: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 14px;
    color: #5E6D82;
    text-align: center;
  }
  .pseudo-link-wrap {
    cursor: pointer;
  }
  .subscribers-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .subscribers-count {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    color: #5E6D82;
    margin-right: 20px;
  }
  .subscribers-links {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }
  .subscribers-links__item {
    margin-right: 10px;
  }
  .subscribers-links__item:last-child {
    margin-right: 0;
  }
  .subscribers__button-wrap {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .subscribers-activities-button {
    margin-left: auto;
    cursor: pointer;
  }
</style>

